import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { WebService } from "../../Services/WebService";
import { Form, FormInputText } from "../Form";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { StandardConst } from "../../Services/StandardConst";

const apiUrl = "CommonUtility/subscription_type";
const { forwardRef, useState, useImperativeHandle } = React;

const AddEditSubscriptionType = (prop, ref) => {
    const dispatch = useDispatch();
    const [show, setShow] = useState(false);
    const [data, setData] = useState({ SubscriptionType: {} });

    useImperativeHandle(ref, () => ({
        openModal: async (id) => {
            setShow(true);
            if (id === 0) {
                setData({ SubscriptionType: {} })
            } else {
                setShow(false);
                const data = {
                    SubscriptionType: await WebService({
                        endPoint: `CommonUtility/Edit/subscription_type?SubscriptionTypeId=${id || 0}`,
                        dispatch,
                    }).then((c) => (c.length > 0 ? c[0] : {}))
                }
                setData(data);
                setShow(true);
            }
        },
    }));
    const handleClose = () => setShow(false);
    const schema = yup
        .object()
        .shape({
            Name: yup.string().trim().required(StandardConst.ValidationMessages.RequiredFieldMsg),
        })
        .required();

    const onSubmit = async (data) => {
        if (data.SubscriptionTypeId === undefined) {
            await WebService({
                endPoint: apiUrl,
                body: data,
                dispatch,
            });
        } else {
            await WebService({
                endPoint: `${apiUrl}?SubscriptionTypeId=${data.SubscriptionTypeId}`,
                method: "PUT",
                body: data,
                dispatch,
            });
        }
        handleClose();
        prop.callBackEvent();
    };
    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>
                    {(data?.SubscriptionType?.SubscriptionTypeId || 0) === 0
                        ? "Add Subscription Type"
                        : "Edit Subscription Type"}
                </Modal.Title>
            </Modal.Header>
            <Form
                defaultValues={data.SubscriptionType}
                onSubmit={onSubmit}
                validationSchema={schema}
            >
                <Modal.Body className="p-4">
                    <div className="row">
                        <div className="col-md-12">
                            <FormInputText
                                label="Name"
                                name="Name"
                                type="text"
                                isRequired="true"
                            />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        id="btnSubmit"
                        variant="outline-primary"
                        type="submit"
                    >
                        {" "}
                        {(data?.SubscriptionType?.SubscriptionTypeId || 0) === 0
                            ? "Submit"
                            : "Save Changes"}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default forwardRef(AddEditSubscriptionType);
